import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function GuaranteeSection() {
  return <section id="guarantee" className="py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-26">
      {/* Subtle calm background glow */}
      <div className="absolute inset-0 bg-calm/5 -z-10" data-id="element-27"></div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-base/80 backdrop-blur-sm border border-calm/30 rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-29">
          <div className="flex justify-center mb-6" data-id="element-30">
            <div className="bg-calm/10 p-5 rounded-full text-calm" data-id="element-31">
              <ShieldCheckIcon size={48} strokeWidth={1.5} data-id="element-32" />
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-main mb-6" data-id="element-33">
            Garantía de "Paz Mental" de 7 Días
          </h2>

          <p className="text-lg md:text-xl text-muted leading-relaxed mb-8" data-id="element-34">
            Probá el método. Si en 7 días no sentís que recuperaste el control
            de tu respiración y tu sueño, te devolvemos el 100% de tu dinero.{' '}
            <strong className="text-calm font-semibold" data-id="element-35">
              El riesgo es todo mío.
            </strong>
          </p>

          <div id="final-cta" className="pt-8 border-t border-white/10" data-id="element-36">
            <CTAButton text="OBTENER ACCESO INMEDIATO POR SOLO ARS 9.500" data-id="element-37" />
            <p className="mt-4 text-sm text-muted opacity-70 tracking-wide" data-id="element-38">
              Acceso inmediato · Pago único y seguro
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}